import React, { useState } from 'react'
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'

const Notifications = () => {
  // Mock notification data for flight supplier
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'booking',
      icon: 'bi-check-circle-fill',
      iconColor: 'text-success',
      title: 'New Booking Confirmed',
      message: 'Booking #BK2024001 for DEL-BOM route has been confirmed. Passenger: John Smith',
      time: '2 minutes ago',
      isRead: false,
      priority: 'high'
    },
    {
      id: 2,
      type: 'payment',
      icon: 'bi-credit-card-fill',
      iconColor: 'text-primary',
      title: 'Payment Received',
      message: 'Payment of ₹15,450 received for booking #BK2024002. Agent: Travel Connect Ltd.',
      time: '15 minutes ago',
      isRead: false,
      priority: 'medium'
    },
    {
      id: 3,
      type: 'cancellation',
      icon: 'bi-x-circle-fill',
      iconColor: 'text-danger',
      title: 'Booking Cancelled',
      message: 'Booking #BK2024003 for BOM-CCU route has been cancelled. Refund initiated.',
      time: '1 hour ago',
      isRead: true,
      priority: 'medium'
    },
    {
      id: 4,
      type: 'inventory',
      icon: 'bi-exclamation-triangle-fill',
      iconColor: 'text-warning',
      title: 'Low Inventory Alert',
      message: 'Only 3 seats remaining for Flight AI-101 DEL-BOM on 2025-09-30. Consider increasing allocation.',
      time: '2 hours ago',
      isRead: false,
      priority: 'high'
    },
    {
      id: 5,
      type: 'agent',
      icon: 'bi-person-plus-fill',
      iconColor: 'text-info',
      title: 'New Agent Registration',
      message: 'New travel agent "Sky Travel Solutions" has registered and is awaiting approval.',
      time: '3 hours ago',
      isRead: true,
      priority: 'low'
    },
    {
      id: 6,
      type: 'system',
      icon: 'bi-gear-fill',
      iconColor: 'text-secondary',
      title: 'System Maintenance',
      message: 'Scheduled maintenance will occur tonight from 11:00 PM to 1:00 AM IST.',
      time: '4 hours ago',
      isRead: true,
      priority: 'medium'
    },
    {
      id: 7,
      type: 'commission',
      icon: 'bi-currency-rupee',
      iconColor: 'text-success',
      title: 'Commission Payment',
      message: 'Commission of ₹2,340 has been credited to agent "Global Tours" for last month.',
      time: '6 hours ago',
      isRead: true,
      priority: 'low'
    },
    {
      id: 8,
      type: 'priceChange',
      icon: 'bi-graph-up-arrow',
      iconColor: 'text-primary',
      title: 'Price Update',
      message: 'Fare prices updated for route DEL-GOA. New base fare: ₹8,500 (Economy Class).',
      time: '8 hours ago',
      isRead: true,
      priority: 'medium'
    },
    {
      id: 9,
      type: 'report',
      icon: 'bi-file-earmark-text',
      iconColor: 'text-info',
      title: 'Weekly Report Generated',
      message: 'Your weekly performance report is ready. Total bookings: 45, Revenue: ₹2,15,000.',
      time: '1 day ago',
      isRead: true,
      priority: 'low'
    },
    {
      id: 10,
      type: 'policy',
      icon: 'bi-shield-check',
      iconColor: 'text-warning',
      title: 'Policy Update',
      message: 'Updated cancellation policy effective from Oct 1, 2025. Please review the changes.',
      time: '2 days ago',
      isRead: true,
      priority: 'high'
    }
  ]);

  const [filter, setFilter] = useState('all');

  const markAsRead = (id) => {
    setNotifications(prev => 
      prev.map(notif => 
        notif.id === id ? { ...notif, isRead: true } : notif
      )
    );
  };

  const markAllAsRead = () => {
    setNotifications(prev => 
      prev.map(notif => ({ ...notif, isRead: true }))
    );
  };

  const deleteNotification = (id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  };

  const filteredNotifications = notifications.filter(notif => {
    if (filter === 'all') return true;
    if (filter === 'unread') return !notif.isRead;
    if (filter === 'read') return notif.isRead;
    return notif.type === filter;
  });

  const unreadCount = notifications.filter(n => !n.isRead).length;

  const getPriorityBadge = (priority) => {
    const badges = {
      high: 'bg-danger',
      medium: 'bg-warning',
      low: 'bg-success'
    };
    return badges[priority] || 'bg-secondary';
  };

return (
  <>
    <PageTitleAndSnackBar pageTitle="Notifications" />

    <section className="section">
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
            <div className="card-body p-4">

              {/* Header */}
              <div className="d-flex align-items-center justify-content-between mb-4">
                <div className="d-flex align-items-center gap-2">
                  <div style={{
                    width: "36px", height: "36px", borderRadius: "10px",
                    background: "linear-gradient(135deg, #0f2557, #1a3a8f)",
                    display: "flex", alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="bi bi-bell-fill text-white" style={{ fontSize: "15px" }}></i>
                  </div>
                  <div>
                    <h6 className="mb-0 fw-bold" style={{ color: "#0f2557", fontSize: "14px" }}>
                      All Notifications
                    </h6>
                    <span style={{ fontSize: "11px", color: "#8a9ab5" }}>
                      {unreadCount > 0
                        ? <><strong style={{ color: "#1a3a8f" }}>{unreadCount}</strong> unread</>
                        : "All caught up"}
                    </span>
                  </div>
                </div>
                <button
                  onClick={markAllAsRead}
                  disabled={unreadCount === 0}
                  className="btn btn-sm fw-semibold d-flex align-items-center gap-2"
                  style={{
                    background: unreadCount === 0 ? "#f4f6fb" : "linear-gradient(135deg, #0f2557, #1a3a8f)",
                    color: unreadCount === 0 ? "#8a9ab5" : "white",
                    border: "none", borderRadius: "8px",
                    fontSize: "12px", height: "34px", padding: "0 14px",
                    boxShadow: unreadCount > 0 ? "0 4px 12px rgba(15,37,87,0.25)" : "none"
                  }}
                >
                  <i className="bi bi-check-all"></i> Mark All as Read
                </button>
              </div>

              {/* Filter Pills */}
              <div className="d-flex gap-2 mb-4 flex-wrap">
                {[
                  { val: "all",       label: "All",       icon: "bi-list-ul" },
                  { val: "unread",    label: "Unread",    icon: "bi-dot" },
                  { val: "payment",   label: "Payments",  icon: "bi-credit-card-fill" },
                  { val: "inventory", label: "Inventory", icon: "bi-exclamation-triangle-fill" },
                ].map(f => (
                  <button
                    key={f.val}
                    onClick={() => setFilter(f.val)}
                    className="btn btn-sm d-flex align-items-center gap-2 fw-semibold"
                    style={{
                      borderRadius: "20px", fontSize: "12px",
                      height: "32px", padding: "0 14px",
                      border: filter === f.val ? "none" : "1.5px solid #dde3ef",
                      background: filter === f.val
                        ? "linear-gradient(135deg, #0f2557, #1a3a8f)"
                        : "white",
                      color: filter === f.val ? "white" : "#6b7280",
                      boxShadow: filter === f.val ? "0 4px 12px rgba(15,37,87,0.25)" : "none",
                      transition: "all 0.15s"
                    }}
                  >
                    <i className={`bi ${f.icon}`} style={{ fontSize: "11px" }}></i>
                    {f.label}
                  </button>
                ))}
              </div>

              {/* Notifications List */}
              <div>
                {filteredNotifications.length === 0 ? (
                  <div className="text-center py-5" style={{ color: "#8a9ab5" }}>
                    <i className="bi bi-bell-slash" style={{ fontSize: "42px", display: "block", marginBottom: "10px" }}></i>
                    <p className="fw-semibold mb-1" style={{ fontSize: "14px", color: "#374151" }}>No notifications found</p>
                    <p style={{ fontSize: "12px" }}>There are no notifications matching your current filter.</p>
                  </div>
                ) : (
                  filteredNotifications.map(notification => {
                    const priorityStyles = {
                      high:   { bg: "#fff1f1", color: "#dc2626" },
                      medium: { bg: "#fffbeb", color: "#b45309" },
                      low:    { bg: "#ecfdf5", color: "#065f46" },
                    };
                    const typeIconBg = {
                      booking:     { bg: "#ecfdf5", color: "#065f46" },
                      payment:     { bg: "#eef0ff", color: "#1a3a8f" },
                      cancellation:{ bg: "#fff1f1", color: "#dc2626" },
                      inventory:   { bg: "#fffbeb", color: "#b45309" },
                      agent:       { bg: "#e0f2fe", color: "#0369a1" },
                      system:      { bg: "#f4f6fb", color: "#374151" },
                      commission:  { bg: "#ecfdf5", color: "#065f46" },
                      priceChange: { bg: "#eef0ff", color: "#1a3a8f" },
                      report:      { bg: "#e0f2fe", color: "#0369a1" },
                      policy:      { bg: "#fffbeb", color: "#b45309" },
                    };
                    const iconStyle = typeIconBg[notification.type] || { bg: "#f4f6fb", color: "#374151" };
                    const p = priorityStyles[notification.priority] || { bg: "#f4f6fb", color: "#374151" };

                    return (
                      <div
                        key={notification.id}
                        onClick={() => markAsRead(notification.id)}
                        style={{
                          display: "flex", alignItems: "flex-start", gap: "14px",
                          padding: "14px 16px", borderRadius: "12px", marginBottom: "8px",
                          border: !notification.isRead ? "1.5px solid #c7d2fe" : "1.5px solid #f0f2f8",
                          background: !notification.isRead ? "#f8f9fe" : "white",
                          cursor: "pointer", transition: "all 0.15s"
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.background = "#f4f6fb";
                          e.currentTarget.style.borderColor = "#dde3ef";
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.background = !notification.isRead ? "#f8f9fe" : "white";
                          e.currentTarget.style.borderColor = !notification.isRead ? "#c7d2fe" : "#f0f2f8";
                        }}
                      >
                        {/* Icon */}
                        <div style={{
                          width: "42px", height: "42px", borderRadius: "12px", flexShrink: 0,
                          background: iconStyle.bg,
                          display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                          <i className={`bi ${notification.icon}`} style={{ fontSize: "17px", color: iconStyle.color }}></i>
                        </div>

                        {/* Content */}
                        <div className="flex-grow-1 overflow-hidden">
                          <div className="d-flex align-items-start justify-content-between gap-2 mb-1">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                              <span style={{ fontSize: "13px", fontWeight: "700", color: "#0f2557" }}>
                                {notification.title}
                              </span>
                              {!notification.isRead && (
                                <span style={{
                                  fontSize: "10px", fontWeight: "700",
                                  background: "linear-gradient(135deg, #0f2557, #1a3a8f)",
                                  color: "white", borderRadius: "6px", padding: "1px 7px"
                                }}>NEW</span>
                              )}
                              <span style={{
                                fontSize: "10px", fontWeight: "700", borderRadius: "6px",
                                padding: "1px 7px", background: p.bg, color: p.color
                              }}>
                                {notification.priority.toUpperCase()}
                              </span>
                            </div>
                            <div className="d-flex align-items-center gap-2 flex-shrink-0">
                              <span style={{
                                fontSize: "10px", color: "#8a9ab5", fontWeight: "600",
                                background: "#f4f6fb", borderRadius: "6px", padding: "2px 8px",
                                whiteSpace: "nowrap"
                              }}>
                                <i className="bi bi-clock me-1"></i>{notification.time}
                              </span>
                              <button
                                onClick={e => { e.stopPropagation(); deleteNotification(notification.id); }}
                                title="Delete"
                                style={{
                                  width: "28px", height: "28px", borderRadius: "7px",
                                  background: "#fff1f1", border: "none", color: "#dc2626",
                                  display: "flex", alignItems: "center", justifyContent: "center",
                                  cursor: "pointer", flexShrink: 0
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = "#fca5a5"}
                                onMouseLeave={e => e.currentTarget.style.background = "#fff1f1"}
                              >
                                <i className="bi bi-trash" style={{ fontSize: "11px" }}></i>
                              </button>
                            </div>
                          </div>
                          <p className="mb-0" style={{ fontSize: "12px", color: "#6b7280", lineHeight: 1.5 }}>
                            {notification.message}
                          </p>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              {/* Load More */}
              {filteredNotifications.length > 0 && (
                <div className="text-center mt-4">
                  <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2 mx-auto"
                    style={{
                      background: "#f4f6fb", color: "#374151",
                      border: "1.5px solid #dde3ef", borderRadius: "8px",
                      fontSize: "12px", height: "34px", padding: "0 20px"
                    }}>
                    <i className="bi bi-arrow-clockwise" style={{ color: "#1a3a8f" }}></i> Load More
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);
}

export default Notifications